import { render, staticRenderFns } from "./TermsView.vue?vue&type=template&id=7ab305e3"
var script = {}
import style0 from "./TermsView.vue?vue&type=style&index=0&id=7ab305e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports